import { APIHelper } from '@/services/axios';
import store from '@/store';

const state = store.state;

const getAvailableSpecialists = () =>
  APIHelper.get(
    `/serviceadvisors?vehicle_model_id=${state.current_user.car.model.id}&service_id=${state.current_schedule.service.id}&branch_id=${state.current_schedule.office.office.id}`,
  );

const getAvailableDates = (from_date, to_date, specialist_id) => {
  if (specialist_id) {
    return APIHelper.get(
      `/availability?user_id=${specialist_id}&service_id=${state.current_schedule.service.id}&branch_id=${state.current_schedule.office.office.id}&from_date=${from_date}&to_date=${to_date}&vehicle_model_id=${state.current_user.car.model.id}`,
    );
  }

  return APIHelper.get(
    `/availability?service_id=${state.current_schedule.service.id}&branch_id=${state.current_schedule.office.office.id}&from_date=${from_date}&to_date=${to_date}&vehicle_model_id=${state.current_user.car.model.id}`,
  );
};

const getAvailableHours = (selected_date, specialist_id) => {
  if (specialist_id) {
    return APIHelper.get(
      `/appointments?user_id=${specialist_id}&service_id=${state.current_schedule.service.id}&branch_id=${state.current_schedule.office.office.id}&appointment_date=${selected_date}&vehicle_model_id=${state.current_user.car.model.id}`,
    );
  }

  return APIHelper.get(
    `/appointments?service_id=${state.current_schedule.service.id}&branch_id=${state.current_schedule.office.office.id}&appointment_date=${selected_date}&vehicle_model_id=${state.current_user.car.model.id}`,
  );
};

export { getAvailableSpecialists, getAvailableDates, getAvailableHours };
